import React, { Component } from 'react';
import './sec4.css';

const Sec4 = () => {
    return (  
        <section id="quote" className="quote-section">

      <span className="quote-decorative">❝</span>

      <div className="quote-inner">

        <p className="quote-text">
          "I have been impressed with the urgency of doing.
          Knowing is not enough; we must apply. Being willing
          is not enough; we must do."
        </p>

        <div className="quote-divider" />

        <p className="quote-attr">
          Leonardo da Vinci · Notebooks · c. 1500
        </p>

      </div>

    </section>
    );
}
 
export default Sec4;